import axiosSecure from '@api/axiosSecure';
import getContextRoot from '@api/getContextRoot';

const listVarietals = async (): Promise<any> => {
  const res = await axiosSecure.get(`${getContextRoot()}/varietal`);
  // const res = await axiosSecure.get(`${getContextRoot()}/varietal?max=25&offset=0`);
  return res.data;
};

export default listVarietals;
